import { jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { token } from "./token.js";
function SkeletonText({
  variant = "primary",
  ...props
}) {
  return /* @__PURE__ */ jsx(TextContainer, {
    "data-testid": "ds-skeleton-text",
    $variant: variant,
    ...props
  });
}
const TextContainer = styled.div.withConfig({
  displayName: "TextContainer",
  componentId: "sc-zxdpcu-0"
})(["display:flex;align-items:center;width:100%;height:20px;&::before{content:'';height:6px;border-radius:", ";", "}"], token.radiusPill, (props) => {
  if (props.$variant === "primary") {
    return css(["width:75%;max-width:240px;background:", ";"], token.gray200a);
  }
  if (props.$variant === "secondary") {
    return css(["width:50%;max-width:160px;background:", ";"], token.gray100a);
  }
});
export {
  SkeletonText,
  TextContainer
};
//# sourceMappingURL=SkeletonText.js.map
